import script from "./IssueCreateOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./IssueCreateOverlay.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QScrollArea,QForm,QItem});
